import { TopProducts, TopProductsProps, TopProductItemProps } from './TopProducts'

export default TopProducts

export { type TopProductsProps, TopProducts, type TopProductItemProps }
